/**
 * Shared utility functions used across multiple pages
 */

/**
 * Normalize string for diacritic-insensitive search (Romanian)
 */
export const normalizeForSearch = (str) => {
  return (str || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
};

/**
 * Extract numeric value from numar_dosar_intern (e.g., "15/2024" -> 15)
 */
export const extractNumarIntern = (numarIntern) => {
  if (!numarIntern) return null;
  const match = numarIntern.match(/^(\d+)/);
  return match ? parseInt(match[1], 10) : null;
};

/**
 * Get CSS class for case stage badge
 */
export const getStageColor = (stage) => {
  const colors = {
    "Urmărire penală": "bg-orange-100 text-orange-700",
    "Cameră preliminară": "bg-purple-100 text-purple-700",
    "Faza prejudiciară": "bg-info/10 text-info",
    "Fond": "bg-primary/10 text-primary",
    "Apel": "bg-warning/10 text-warning",
    "Recurs": "bg-accent/10 text-accent",
    "Rejudecare fond": "bg-destructive/10 text-destructive",
    "Rejudecare apel": "bg-warning/10 text-warning",
    "Executare silită": "bg-success/10 text-success",
    "Închis": "bg-muted text-muted-foreground",
    "Altele": "bg-gray-100 text-gray-600",
  };
  return colors[stage] || "bg-secondary text-secondary-foreground";
};

/**
 * Determine payment status for a financial record
 * Returns: "incasat" | "partial" | "neincasat" | "fara_date"
 */
export const getPaymentStatus = (record) => {
  const facturat = record.total_facturi || 0;
  const incasat = record.total_incasat || 0;
  const restant = record.total_neincasat || 0;
  if (facturat <= 0) return "fara_date";
  if (restant <= 0 && incasat > 0) return "incasat";
  if (incasat > 0 && restant > 0) return "partial";
  return "neincasat";
};
